export default __webpack_public_path__ + "static/media/ic-quantity-20k.0b631049.svg";